import React from 'react';
import { Bell as BellIcon } from 'react-feather';
import { createStyles, makeStyles } from '@material-ui/styles';
import { ClickAwayListener, Tooltip } from '@material-ui/core';
import { Badge, JupiterTheme, MockHook } from '@jupiterone/jupiter-web-toolkit';
import NotificationsDrawer from 'navbar/src/notifications/NotificationsDrawer';
import useNotificationsDrawerLogic, {
  NotificationsComponentProps,
} from 'navbar/src/notifications/NotificationsDrawer/useNotificationsDrawerLogic';
import NewNotificationsPopover from 'navbar/src/notifications/NewNotificationsPopover';

const useStyles = makeStyles((theme: JupiterTheme) => {
  const NAV_ICON_SIZE = 28;
  const NAV_ICON_SIZE_SPACING = theme.spacing(2.5);
  return createStyles({
    notificationsButton: {
      height: 28,
      '& svg': {
        width: NAV_ICON_SIZE,
        height: NAV_ICON_SIZE,
        marginLeft: NAV_ICON_SIZE_SPACING,
        cursor: 'pointer',
        '&.active': {
          color: theme.palette.primary.light,
        },
        '&:hover': {
          color: theme.palette.primary.light,
        },
        '&:focus': {
          outline: 'none',
        },
      },
    },
    badge: {
      padding: theme.spacing(0.5),
    },
  });
});

const Notifications = ({
  loading,
  isDrawerOpen,
  notifications,
  unreadNotifications,
  handleNotificationClick,
  toggleDrawer,
  handleClose,
}: NotificationsComponentProps) => {
  const classes = useStyles();

  return (
    <ClickAwayListener onClickAway={() => isDrawerOpen && handleClose()}>
      <div>
        <NewNotificationsPopover
          unreadNotifications={unreadNotifications}
          onClick={toggleDrawer}
        >
          <div
            data-testid="notifications-drawer-icon"
            className={classes.notificationsButton}
          >
            <Badge
              aria-haspopup="true"
              overlap="circle"
              size="MEDIUM"
              status="ERROR"
              anchorOrigin={{
                horizontal: 'right',
                vertical: 'top',
              }}
              showZero={false}
              badgeContent={unreadNotifications.length}
              invisible={unreadNotifications.length === 0}
              onClick={toggleDrawer}
              classes={{ anchorOriginTopRightCircle: classes.badge }}
            >
              <Tooltip title="Notifications" enterDelay={750}>
                <div>
                  <BellIcon aria-label="Notifications" aria-haspopup="true" />
                </div>
              </Tooltip>
            </Badge>
          </div>
        </NewNotificationsPopover>
        <NotificationsDrawer
          notifications={notifications}
          loading={loading}
          isDrawerOpen={isDrawerOpen}
          handleNotificationClick={handleNotificationClick}
          handleClose={handleClose}
        />
      </div>
    </ClickAwayListener>
  );
};

export default MockHook.withHookHoc(Notifications, useNotificationsDrawerLogic);
